export default "__VITE_ASSET__CgqEkw3X__"